import React from 'react';
import { CircleUser as UserCircle, ListChecks, Users } from 'lucide-react';
import { cn } from '../../../lib/utils';

export type TabId = 'information' | 'criteria' | 'matching';

interface Tab {
  id: TabId;
  label: string;
  icon: React.ElementType;
}

const tabs: Tab[] = [
  { id: 'information', label: 'Informations', icon: UserCircle },
  { id: 'criteria', label: 'Critères', icon: ListChecks },
  { id: 'matching', label: 'Finalisation', icon: Users },
];

interface ClientFormTabsProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
}

export const ClientFormTabs: React.FC<ClientFormTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  return (
    <div className="border-b border-gray-200 dark:border-gray-700">
      <nav className="flex space-x-4 sm:space-x-8 px-4 sm:px-6 overflow-x-auto scrollbar-hide overscroll-x-contain" aria-label="Tabs">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={cn(
                'group inline-flex items-center gap-2 border-b-2 px-3 sm:px-1 py-4 sm:py-4 text-base sm:text-sm font-medium whitespace-nowrap touch-manipulation',
                activeTab === tab.id
                  ? 'border-primary-500 text-primary-500'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
              )}
            >
              <Icon className="h-5 w-5" />
              {tab.label}
            </button>
          );
        })}
      </nav>
    </div>
  );
};